/* eslint-disable react/prop-types */
import GeographicalAreaComponent from "./geographilcal-area";
import { useState, useEffect } from "react";
import regionsFile from "@/static-texts/regions.json";
import { setAllChoicesToValue } from "@/common/announcement-helper";
const { regioni, citta } = regionsFile;

const REGION_PLACEHOLDER = "Seleziona la regione";
const CITY_PLACEHOLDER = "Seleziona la provincia";

function GeographicalArea({ announcement, updateAnnouncement }) {
  const [isNational, setIsNational] = useState(false);

  const [regions, setRegions] = useState(
    initializeList(regioni, announcement.regions, true)
  );

  const [selectedRegion, setSelectedRegion] = useState(
    announcement.regions ? announcement.regions : REGION_PLACEHOLDER
  );

  const [cities, setCities] = useState(
    initializeCitiesList(announcement.regions, announcement.cities, true)
  );
  const [selectedCities, setSelectedCities] = useState(
    announcement.cities ? announcement.cities : CITY_PLACEHOLDER
  );

  useEffect(() => {
    const regionsOfInterest = regions.filter(
      ({ isSelected }) => isSelected === true
    );
    if (regionsOfInterest?.length) {
      setSelectedRegion(regionsOfInterest);
    } else {
      setSelectedRegion(REGION_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions]);

  useEffect(() => {
    if (selectedRegion !== REGION_PLACEHOLDER) {
      const list = toListOfNames(selectedRegion);
      updateAnnouncement("regions", list, announcement);
      updateSelectableCities(list, cities, setCities, selectedCities);
    } else {
      updateAnnouncement("regions", [], announcement);
      setCities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegion]);

  useEffect(() => {
    const citiesOfInterest = cities.filter(
      ({ isSelected }) => isSelected === true
    );
    if (citiesOfInterest?.length) {
      setSelectedCities(citiesOfInterest);
    } else {
      setSelectedCities(CITY_PLACEHOLDER);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cities]);

  useEffect(() => {
    if (selectedCities !== CITY_PLACEHOLDER) {
      const list = toListOfNames(selectedCities);

      updateAnnouncement("cities", list, announcement);
    } else {
      updateAnnouncement("cities", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCities]);

  const handleRegionSelect = ({ name }) => {
    setRegions(updateMuliChoiceList(name, regions));
  };

  const handleCitySelect = ({ name }) => {
    setCities(updateMuliChoiceList(name, cities));
  };

  const handleNationalSelcet = (isChecked) => {
    setIsNational(isChecked);
    setCities(setAllChoicesToValue(citta, isChecked));
    setRegions(setAllChoicesToValue(regions, isChecked));
  };

  return (
    <GeographicalAreaComponent
      isRegionValid={selectedRegion !== REGION_PLACEHOLDER}
      isCityValid={selectedCities !== CITY_PLACEHOLDER}
      selectedRegion={selectedRegion}
      selectedCities={selectedCities}
      regions={regions}
      cities={cities}
      onCitySelect={handleCitySelect}
      onRegionSelect={handleRegionSelect}
      isNational={isNational}
      onNationalSelcet={handleNationalSelcet}
    />
  );
}

function updateSelectableCities(list, cities, setCities, selectedCities) {
  let avaiableCities = [];
  list.forEach((region) => {
    const listOfCities = regionsFile[`${region}`];
    avaiableCities = avaiableCities.concat(
      listOfCities?.map((city) => {
        const found =
          selectedCities !== CITY_PLACEHOLDER
            ? selectedCities?.find(({ name }) => name === city.name)
            : undefined;
        return {
          ...city,
          isSelected: found !== undefined,
        };
      })
    );
  });
  setCities(avaiableCities);
}
function initializeList(list, selectedNames, sort) {
  if (sort) {
    list = list.sort((item1, item2) => {
      if (item1.name < item2.name) return -1;
      if (item1.name > item2.name) return 1;
      else return 0;
    });
  }
  return list.map((object) => {
    var found = selectedNames?.find((name) => name === object.name);
    return {
      ...object,
      isSelected: found !== undefined,
    };
  });
}

function initializeCitiesList(regions, selectedNames, sort) {
  let list = [];
  if (!regions?.length || !selectedNames?.length) {
    return list;
  } else {
    regions.forEach((region) => {
      const listOfCities = regionsFile[`${region}`];
      list = list.concat(
        listOfCities?.map((city) => {
          return city;
        })
      );
    });
  }
  if (sort) {
    list = list.sort((item1, item2) => {
      if (item1.name < item2.name) return -1;
      if (item1.name > item2.name) return 1;
      else return 0;
    });
  }
  return list.map((object) => {
    var found = selectedNames?.find((name) => name === object.name);
    return {
      ...object,
      isSelected: found !== undefined,
    };
  });
}

function updateMuliChoiceList(name, list) {
  return list.map((obj) => {
    return {
      ...obj,
      isSelected: obj.name === name ? !obj.isSelected : obj.isSelected,
    };
  });
}

function toListOfNames(list) {
  return list.map((obj) => {
    if (typeof obj === "string" || obj instanceof String) {
      return obj;
    } else {
      return obj.name;
    }
  });
}
export default GeographicalArea;
